export enum TipoSnackBarUtil {
  ERROR = 'ERROR',
  OK = 'OK'
}

